import { customElement } from "solid-element";
import { Show, createSignal, onCleanup, onMount } from "solid-js";

customElement("builderall-loader", { loading: false, blur: true, text: null, carousel: false }, props => {
  import("@lottiefiles/lottie-player");

  const [currentText, setCurrentText] = createSignal("");
  let intervalId: any;

  onMount(() => {
    if (!props.text) return;

    const isCarousel = props.carousel === true || props.carousel === "true";

    if (isCarousel) {
      const messages = props.text.split("|").map(t => t.trim()).filter(Boolean);

      if (messages.length > 1) {
        let index = 0;
        setCurrentText(messages[index]);

        intervalId = setInterval(() => {
          index = (index + 1) % messages.length;
          setCurrentText(messages[index]);
        }, 5000);
      } else {
        setCurrentText(messages[0]);
      }
    } else {
      setCurrentText(props.text);
    }
  });

  onCleanup(() => {
    if (intervalId) clearInterval(intervalId);
  });

  return (
    <>
      <style>{require("bundle-text:./styles/index.scss")}</style>
      <div class="loader">
        <slot />
        <Show when={props.loading}>
          <div classList={{ 'loader__overlay': true, 'show__blur': props.blur }}>
            {/* @ts-ignore */}
            <lottie-player
              class="loader__player"
              autoplay
              loop
              mode="normal"
              src={require("bundle-text:./assets/animation.lottie")}
            />
            <Show when={currentText()}>
              <span innerHTML={currentText()}></span>
            </Show>
          </div>
        </Show>
      </div>
    </>
  );
});
